var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"v-add-btn"},'button',_vm.$attrs,false),_vm.$listeners),[_c('PlusIcon',{attrs:{"size":"3rem"}}),_vm._v("\n  Add\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }